const axios = require('axios');
import AuthStore from '../stores/AuthStore';

function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}

class OdooClass{
    constructor() {
      this.conf()
    }

    conf(){
      if(window.confMode && typeof localStorage.getItem('odoo_conf_url') == 'string'){
        window.ODOO.url = localStorage.getItem('odoo_conf_url')
      }
      if(window.confMode && typeof localStorage.getItem('odoo_conf_port') == 'string'){
        window.ODOO.port = localStorage.getItem('odoo_conf_port')
      }
      const conf = window.ODOO
      this.url = conf.url + (conf.port?':'+conf.port:'')+'/packing/'
    }

    call(model, method, params, login, password, pack_password) {
      if(window.confMode === true){
        this.conf()
      }
      let log = login || AuthStore.getUser().login
      let pwd = password || AuthStore.getUser().password
      let pack_pwd = pack_password || AuthStore.getUser().pack_password
      let req = {
        'login': log,
        'password': pwd,
        'pack_password': pack_pwd,
        'model': model,
        'method': method,
        'params': params
      }
      req = b64EncodeUnicode(JSON.stringify(req))
      req = req.replace(/\//g, '_')
      let spinner = document.querySelector('.loaderWrap')
      let spinnerTimout = setTimeout(()=>{
        spinner.style.display = 'block'
      }, 1000)

      return new Promise((resolve, reject) => {
        axios.get(this.url+req/*, {withCredentials: true}*/)
          .then(function (response) {
            if(response.status == 200){
              if(response.data.error){
                reject(response.data.message)
              }
              resolve(response.data)
            } else {
              reject('Wystąpił nieznany błąd')
            }
          })
          .catch(function () {
            // handle error
            reject('Wystąpił nieznany błąd')
          }).then(() => {
            spinner.style.display = 'none'
            clearTimeout(spinnerTimout)
          })
      });
    }
}

const Odoo = new OdooClass();

export default Odoo;



// WEBPACK FOOTER //
// ./src/utils/Odoo.js